// ST1 Sports — Drawer Accordion (v12 — fully menu-driven mobile nav)
// Desktop: .toggle-drawer-menu .drawer-menu__sub-panel (CSS max-height accordion)
//          initDesktopPanel() adds L2/L3 click-expand within each sport sub-panel
// Mobile:  rebuilds the whole drawer from #st1-sport-menu-data JSON.
//          Both "Shop by Sport" AND the main nav (Apparel / Footwear / Eyewear /
//          Sale / Team Gear / Custom Team Store) now come from real Shopify menus,
//          3 levels deep, so mobile always mirrors the desktop dropdown.
//
// v12 changes:
//   - Main nav is no longer a hardcoded 2-level array. It reads DATA.nav, which
//     snippets/st1-sport-menu-data.liquid builds from apparel-menu / footwear-menu /
//     eyewear-menu. Edit those menus in Shopify admin and mobile follows.
//   - Removed the unreachable legacy initMobileNav() body and the /collections.json
//     prefetch (getCollectionMap), which ran on every page load for nothing.

(function () {
  'use strict';

  function sp(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

  function stripPrefix(text) {
    var idx = text.indexOf(' – ');
    if (idx !== -1) return text.slice(idx + 3).trim();
    var parts = text.split(' - ');
    if (parts.length > 1) return parts[parts.length - 1].trim();
    return text;
  }

  function startsWithAll(text) {
    return /^all\b/i.test(String(text || '').trim());
  }

  // ── DESKTOP ──────────────────────────────────────────────────────────────
  // Adds click-expand accordion within each sport's sub-panel (L2 → L3)
  function initDesktopPanel(panel) {
    if (panel.dataset.st1Init) return;

    var hdrItems = Array.from(panel.querySelectorAll('li.mega-menu__item')).filter(function (li) {
      return !li.classList.contains('drawer-menu-item');
    });
    if (!hdrItems.length) return;
    panel.dataset.st1Init = '1';

    var lv1 = panel.closest('.drawer-menu-lv1');
    if (lv1 && !lv1.dataset.st1HoverFixed) {
      lv1.dataset.st1HoverFixed = '1';
      ['mouseenter', 'mouseleave'].forEach(function (evt) {
        lv1.addEventListener(evt, function (e) { e.stopImmediatePropagation(); }, true);
      });
    }

    hdrItems.forEach(function (li) {
      var hdrP  = li.querySelector('p.drawer-menu-item-lv-2');
      var hdrA  = hdrP && hdrP.querySelector('a');
      var subUl = li.querySelector('ul.last-level-menu');
      if (!hdrP || !hdrA) return;

      li.classList.add('st1-l2-hdr');
      hdrA.classList.remove('link-animation');

      sp(hdrP, 'display', 'flex'); sp(hdrP, 'align-items', 'center');
      sp(hdrP, 'width', '100%'); sp(hdrP, 'box-sizing', 'border-box');
      sp(hdrP, 'padding', '11px 16px'); sp(hdrP, 'margin', '0');
      sp(hdrP, 'background', '#f2f2f2'); sp(hdrP, 'border-bottom', '1px solid #ddd');
      sp(hdrP, 'cursor', subUl ? 'pointer' : 'default');

      sp(hdrA, 'flex', '1'); sp(hdrA, 'display', 'block');
      sp(hdrA, 'color', '#333'); sp(hdrA, 'font-size', '0.88rem');
      sp(hdrA, 'font-weight', '600'); sp(hdrA, 'text-decoration', 'none');
      sp(hdrA, 'background', 'transparent');

      if (!subUl) return;

      sp(subUl, 'display', 'none'); sp(subUl, 'margin', '0'); sp(subUl, 'padding', '0');

      Array.from(subUl.querySelectorAll('li a')).forEach(function (a) {
        var s = stripPrefix(a.textContent.trim());
        if (s !== a.textContent.trim()) a.textContent = s;
        sp(a, 'display', 'block'); sp(a, 'width', '100%');
        sp(a, 'box-sizing', 'border-box'); sp(a, 'padding', '8px 16px 8px 36px');
        sp(a, 'font-size', '0.83rem'); sp(a, 'color', '#555');
        sp(a, 'background', '#fafafa'); sp(a, 'border-bottom', '1px solid #ebebeb');
        sp(a, 'text-decoration', 'none');
        a.addEventListener('mouseenter', function () { sp(a, 'color', '#F37321'); sp(a, 'background', '#fff5ee'); });
        a.addEventListener('mouseleave', function () { sp(a, 'color', '#555');    sp(a, 'background', '#fafafa'); });
      });

      var chev = document.createElement('span');
      chev.textContent = '›';
      sp(chev, 'font-size', '1.1rem'); sp(chev, 'color', '#999');
      sp(chev, 'display', 'inline-block'); sp(chev, 'transition', 'transform 0.2s');
      sp(chev, 'flex-shrink', '0'); sp(chev, 'margin-left', '4px');
      hdrP.appendChild(chev);

      var open = false;
      hdrP.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        open = !open;
        sp(subUl, 'display', open ? 'block' : 'none');
        chev.style.setProperty('transform', open ? 'rotate(90deg)' : 'rotate(0deg)', 'important');
      });
      hdrP.addEventListener('mouseenter', function () { sp(hdrP, 'background', '#e8e8e8'); });
      hdrP.addEventListener('mouseleave', function () { sp(hdrP, 'background', '#f2f2f2'); });
    });
  }

  // ── MOBILE ───────────────────────────────────────────────────────────────
  // Everything below is built from #st1-sport-menu-data (see the liquid snippet).

  function initMobileNav() { return st1BuildMobileNavFromMenu(); }

  function st1BuildMobileNavFromMenu() {
    if (window.innerWidth >= 1024) return;
    if (document.getElementById('st1-mobile-sport')) return;
    var dataEl = document.getElementById('st1-sport-menu-data');
    if (!dataEl) return;
    var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sports = (DATA && DATA.sports) || [];
    var navItems = (DATA && DATA.nav) || [];
    if (!sports.length && !navItems.length) return;
    var mobileNavContent =
      document.querySelector('.main-nav-mobile .scrollbar-body') ||
      document.querySelector('.main-nav-mobile .overflow-y-auto') ||
      document.querySelector('.main-nav-mobile') ||
      document.querySelector('.mobile-menu-drawer .scrollbar-body') ||
      document.querySelector('.mobile-menu-drawer') ||
      document.querySelector('nav.main-nav-mobile');
    if (!mobileNavContent) return;

    function strip(t) { return stripPrefix(String(t || '').trim()); }

    // Shared row styles so sport and main nav look identical at every level.
    var CSS_L1   = 'display:flex;align-items:center;justify-content:space-between;padding:14px 12px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
    var CSS_L1_T = 'font-size:1rem;font-weight:700;color:#424242;font-family:Lexend,sans-serif;';
    var CSS_L2   = 'display:flex;align-items:center;padding:11px 12px 11px 28px;background:#f5f5f5;border-bottom:1px solid #e5e7eb;cursor:pointer;';
    var CSS_L2_T = 'flex:1;color:#333;font-size:.88rem;font-weight:600;font-family:Lexend,sans-serif;';
    var CSS_L2_C = 'font-size:.95rem;color:#999;display:inline-block;transition:transform .2s;flex-shrink:0;margin-left:6px;';
    var CSS_L2_LEAF = 'display:block;padding:11px 12px 11px 28px;background:#f5f5f5;border-bottom:1px solid #e5e7eb;color:#333;font-size:.88rem;font-weight:600;font-family:Lexend,sans-serif;text-decoration:none;';
    var CSS_L3   = 'display:block;padding:9px 12px 9px 44px;color:#555;font-size:.83rem;font-family:Lexend,sans-serif;text-decoration:none;border-bottom:1px solid #f0f0f0;';
    var CSS_L3_T = 'color:#555;font-size:.83rem;font-weight:400;font-family:Lexend,sans-serif;';

    // The theme sets font-family:"Lexend Zetta" and a letter-spacing on nav <a>
    // tags with !important, so a bare link renders wider and lighter than the
    // <span>-based rows next to it. Wrapping the label in a span — and forcing
    // the font on both — makes leaf links match their sibling rows exactly.
    function makeLink(href, text, anchorCss, labelCss) {
      var a = document.createElement('a');
      a.href = href;
      a.style.cssText = anchorCss;
      sp(a, 'font-family', 'Lexend, sans-serif');
      sp(a, 'letter-spacing', 'normal');
      var s = document.createElement('span');
      s.textContent = text;
      s.style.cssText = labelCss;
      sp(s, 'font-family', 'Lexend, sans-serif');
      sp(s, 'letter-spacing', 'normal');
      a.appendChild(s);
      return a;
    }

    // Renders a list of {title,url,subs[]} as L2 accordion rows with L3 links.
    function renderLevel2(container, children) {
      children.forEach(function (kid) {
        var subs = kid.subs || [];
        var label = strip(kid.title);

        if (!subs.length) {
          container.appendChild(makeLink(kid.url, label, CSS_L2_LEAF, CSS_L2_T));
          return;
        }

        var l2Row = document.createElement('div');
        l2Row.style.cssText = CSS_L2;
        var l2l = document.createElement('span');
        l2l.textContent = label;
        l2l.style.cssText = CSS_L2_T;
        l2Row.appendChild(l2l);
        var l2c = document.createElement('span');
        l2c.textContent = '›';
        l2c.style.cssText = CSS_L2_C;
        l2Row.appendChild(l2c);
        container.appendChild(l2Row);

        var l3List = document.createElement('div');
        l3List.style.cssText = 'display:none;background:#fafafa;';
        container.appendChild(l3List);

        // Keep the parent collection reachable from inside the expanded group.
        if (kid.url && !startsWithAll(label)) {
          l3List.appendChild(makeLink(kid.url, 'All ' + label, CSS_L3, CSS_L3_T));
        }

        subs.forEach(function (sub) {
          l3List.appendChild(makeLink(sub.url, strip(sub.title), CSS_L3, CSS_L3_T));
        });

        l2Row.addEventListener('click', function (e) {
          e.stopPropagation();
          var o = l3List.style.display === 'none';
          l3List.style.display = o ? 'block' : 'none';
          l2c.style.transform = o ? 'rotate(90deg)' : 'none';
          l2Row.style.background = o ? '#ececec' : '#f5f5f5';
        });
      });
    }

    // ── Shop by Sport (drill-down at L1, accordion at L2/L3) ──────────────
    var wrap = document.createElement('div');
    wrap.id = 'st1-mobile-sport';
    wrap.style.borderBottom = '1px solid #e5e7eb';

    var topRow = document.createElement('div');
    topRow.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:16px 12px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
    var topLabel = document.createElement('span');
    topLabel.textContent = 'Shop by Sport';
    topLabel.style.cssText = CSS_L1_T;
    var topChev = document.createElement('span');
    topChev.textContent = '›';
    topChev.style.cssText = 'font-size:1.3rem;color:#F37321;display:inline-block;transition:transform .25s;margin-left:14px;';
    topRow.appendChild(topLabel); topRow.appendChild(topChev); wrap.appendChild(topRow);

    var sportList = document.createElement('div');
    sportList.style.cssText = 'display:none;background:#f9f9f9;';
    wrap.appendChild(sportList);
    topRow.addEventListener('click', function () {
      var o = sportList.style.display === 'none';
      sportList.style.display = o ? 'block' : 'none';
      topChev.style.transform = o ? 'rotate(90deg)' : 'none';
    });

    var backRow = document.createElement('div');
    backRow.style.cssText = 'display:none;align-items:center;padding:14px 12px;cursor:pointer;background:#fff;border-bottom:1px solid #e5e7eb;';
    var backLabel = document.createElement('span');
    backLabel.style.cssText = 'font-size:.95rem;font-weight:700;color:#F37321;font-family:Lexend,sans-serif;';
    backRow.appendChild(backLabel);
    sportList.appendChild(backRow);

    var sportRows = [], catPanels = [];
    function showSports() {
      topRow.style.display = '';
      backRow.style.display = 'none';
      sportRows.forEach(function (r) { r.style.display = 'flex'; });
      catPanels.forEach(function (c) { c.style.display = 'none'; });
    }
    function drill(panel, name) {
      topRow.style.display = 'none';
      backLabel.textContent = '‹  ' + name;
      backRow.style.display = 'flex';
      sportRows.forEach(function (r) { r.style.display = 'none'; });
      catPanels.forEach(function (c) { c.style.display = (c === panel) ? 'block' : 'none'; });
    }
    backRow.addEventListener('click', showSports);

    sports.forEach(function (sport) {
      if (!sport.title) return;
      var sportRow = document.createElement('div');
      sportRow.style.cssText = 'display:flex;align-items:center;padding:12px 12px 12px 20px;background:#f2f2f2;border-bottom:1px solid #e5e7eb;cursor:pointer;';
      var sl = document.createElement('span');
      sl.textContent = sport.title;
      sl.style.cssText = 'flex:1;color:#333;font-size:.92rem;font-weight:600;font-family:Lexend,sans-serif;';
      sportRow.appendChild(sl);
      var sc = document.createElement('span');
      sc.textContent = '›';
      sc.style.cssText = 'font-size:1rem;color:#999;display:inline-block;flex-shrink:0;margin-left:8px;';
      sportRow.appendChild(sc);
      sportList.appendChild(sportRow);

      var catPanel = document.createElement('div');
      catPanel.style.cssText = 'display:none;background:#fff;';
      sportList.appendChild(catPanel);
      sportRows.push(sportRow); catPanels.push(catPanel);

      var cats = sport.categories || [];
      if (!cats.length) {
        sportRow.addEventListener('click', function () { window.location.href = sport.url; });
        return;
      }
      sportRow.addEventListener('click', function () { drill(catPanel, sport.title); });
      renderLevel2(catPanel, cats);
    });

    mobileNavContent.insertBefore(wrap, mobileNavContent.firstChild);

    // ── Main nav (Apparel / Footwear / Eyewear / …) ───────────────────────
    // Same 3-level shape as sport, sourced from apparel-menu / footwear-menu /
    // eyewear-menu via the liquid snippet. Nothing is hardcoded here.
    var nav = document.createElement('div');
    nav.id = 'st1-mobile-nav';

    navItems.forEach(function (item) {
      var kids = (item.children || []).slice();

      // Collapse a redundant single "All X" wrapper. Eyewear's menu is
      // Eyewear > All Eyewear > 4 activity links, which buried the activities
      // behind a second, pointless tap. Hoist them up a level and leave
      // "All Eyewear" as a plain link alongside them.
      if (kids.length === 1 && startsWithAll(strip(kids[0].title)) && (kids[0].subs || []).length) {
        var only = kids[0];
        kids = [{ title: only.title, url: only.url, subs: [] }].concat(
          (only.subs || []).map(function (s) { return { title: s.title, url: s.url, subs: [] }; })
        );
      }

      // Give the top-level collection its own link, since tapping the row expands.
      if (kids.length && item.url) {
        var hasAll = kids.some(function (k) { return startsWithAll(strip(k.title)); });
        if (!hasAll) kids.unshift({ title: 'All ' + item.title, url: item.url, subs: [] });
      }

      var row = document.createElement('div');
      row.style.cssText = CSS_L1;
      var lbl = document.createElement('span');
      lbl.textContent = item.title;
      lbl.style.cssText = CSS_L1_T;
      row.appendChild(lbl);
      var chev = document.createElement('span');
      chev.style.cssText = 'font-size:1.3rem;color:#F37321;display:inline-block;transition:transform .25s;';
      row.appendChild(chev);
      nav.appendChild(row);

      if (!kids.length) {
        row.addEventListener('click', function () { window.location.href = item.url; });
        return;
      }

      chev.textContent = '›';
      var sub = document.createElement('div');
      sub.style.cssText = 'display:none;background:#f9f9f9;';
      nav.appendChild(sub);
      row.addEventListener('click', function () {
        var o = sub.style.display === 'none';
        sub.style.display = o ? 'block' : 'none';
        chev.style.transform = o ? 'rotate(90deg)' : 'none';
      });

      renderLevel2(sub, kids);
    });

    wrap.insertAdjacentElement('afterend', nav);

    // We now own all nav content — hide everything the theme injected.
    Array.prototype.slice.call(mobileNavContent.children).forEach(function (child) {
      if (child.id === 'st1-mobile-sport' || child.id === 'st1-mobile-nav') return;
      child.style.setProperty('display', 'none', 'important');
    });
  }

  // ── INIT ─────────────────────────────────────────────────────────────────
  function initDesktop() {
    document.querySelectorAll('.drawer-menu__sub-panel').forEach(function (panel) {
      initDesktopPanel(panel);
      if (!panel._st1obs) {
        panel._st1obs = new MutationObserver(function () { initDesktopPanel(panel); });
        panel._st1obs.observe(panel, { childList: true, subtree: true });
      }
    });
  }

  // Desktop: watch drawer section for lazily-rendered panels
  var drawerInitTimer = null;
  function attachDrawerObs() {
    var sect = document.querySelector('.x-drawer-menu');
    if (sect && !sect._st1DrawerObs) {
      sect._st1DrawerObs = true;
      new MutationObserver(function () {
        clearTimeout(drawerInitTimer);
        drawerInitTimer = setTimeout(function () {
          initDesktop();
          initMobileNav();
        }, 150);
      }).observe(sect, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attachDrawerObs(); initDesktop(); });
  } else {
    attachDrawerObs();
    initDesktop();
  }

  document.addEventListener('shopify:section:load', function () { attachDrawerObs(); initDesktop(); initMobileNav(); });

  // Body class change fires after Alpine finishes rendering the drawer — use for mobile
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].type === 'childList') attachDrawerObs();
      // Class change = drawer opened/closed
      initMobileNav();
      initDesktop();
      break;
    }
  }).observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });
})();
